// extracted by mini-css-extract-plugin
export default {"loadMoreWrapper":"IssueTimeline-module__loadMoreWrapper--RVb8K"};